import i18n from 'i18next';
import { black, white, functional, promo100, system050, system900 } from 'Mui/styles/color';
import { froalaKeyVisionTypeMapping, coverImg } from 'components/KeyVision/config';
import { bgTypes } from 'styles/generateBgStyleByType';
import { SHARE_CARD_IMAGE_TYPES } from 'editor/game_mgmShare/utils/constants';

// Search Bar 下拉選單 => 無：0, 參加者：1, 作品標題：2
export const searchTypes = {
    NO_SEARCH: 0,
    AUTHOR_NAME: 1,
    PORTFOLIO_NAME: 2
};

// Tab 切換 => 作品集：1, 作品頁：2
export const PageType = {
    COLLECTIONS: 0,
    PORTFOLIO: 1
};

// 預設排列樣式 => 隨機：0, 排名：1, 參加時間：2
export const SortTypeMapping = {
    RANDOM: 0,
    RANK: 1,
    TIME: 2
};
// 圖片顯示方式 => 方形裁切：1, 原始比例：2
export const ImageShowTypeMapping = {
    ORIGIN: 1,
    SQUARE: 2
};

// 黑色：1,白色：2
export const MaskTypeMapping = {
    BLACK: 1,
    WHITE: 2
};

// 設計作品集 ＆ 作品頁
export const ugcGameSetting = {
    // 功能列
    headerFunctionSettings: {
        defaultSortType: SortTypeMapping.RANDOM,
        defaultHomePageButtonText: i18n.t('lable.ugc.default_homepage_button_text'),
        textColor: black.color,
        bgColor: white.color
    },
    // 主視覺
    masterVisionSettings: {
        isShowKeyVision: true,
        defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
        customImgUrl: coverImg.cover_ugc,
        customMobileImgUrl: coverImg.cover_ugc,
        bgType: bgTypes.FROALA,
        froalaEditor: `
            <h2 class="section-title" style="text-align: center; padding: 24px; width:100%">
                <span style="color: ${white.color};">
                    <strong class="bold">
                        
                    </strong>
                </span>
            </h2>
        `,
        bgColor: '#003BBD'
    },
    // 作品卡片
    cardSettings: {
        defaultImgShowType: ImageShowTypeMapping.ORIGIN,
        // 顯示作品資訊
        isShowWorkInformation: true,
        textColor: black.color,
        bgColor: white.color,
        defaultMaskStyle: MaskTypeMapping.BLACK
    },
    // 主題
    topicSettings: {
        // 顯示投稿資訊
        isShowSubmitInformation: true,
        isShowVoteInformation: true,
        textColor: black.color,
        bgColor: system050.color
    },
    // 社群分享
    shareButtonSettings: {
        textColor: white.color,
        bgColor: functional.color,
        enableFacebookCommentsPlugin: true
    },
    // 投票按鈕
    voteButtonSettings: {
        textColor: white.color,
        bgColor: functional.color,
        borderColor: promo100.color
    },
    workPageShareCardSettings: {
        // 邀請按鈕文字
        buttonText: i18n.t('default_val.sign_up.referral_code_card.button_text'),
        // 邀請按鈕文字顏色
        buttonTextColor: white.color,
        // 邀請按鈕背景顏色
        buttonBgColor: system900.color,
        // 主題文字顏色
        themeTextColor: system900.color,
        // 主題背景顏色
        themeBgColor: white.color,
        //分享管道設定
        shareChannel: {
            LINE: true,
            FACEBOOK: true,
            WHATSAPP: false,
            X: false,
            COPY: true,
            OTHER: true
        },
        resultImageType: SHARE_CARD_IMAGE_TYPES.WORK_PAGE
    }
};
